var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.component)?_c(_vm.content.component,{tag:"component",staticClass:"landing"}):(_vm.content.html)?_c('div',{staticClass:"landing",domProps:{"innerHTML":_vm._s(_vm.content.html)}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ea75d2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Landing.vue
// module id = 132
// module chunks = 0